export default __webpack_public_path__ + "493be3fa8939e62031e2b890983cba42.svg";